import React from 'react'

import lang from '@/lang'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import cleverreachBackgroundImage from '@assets/images/clever-reach-background.png'

const CreateImage = (props) => {
  const { syncDetails } = props
  const classes = useStyles()
  const { customers } = syncDetails

  if (customers) {
    const { companyCustomers, contactPersons, privateCustomers } = customers
    const contactPersonBlock = (
      <div className={clsx(classes.blockContactPerson, classes.smallBlock)}>
        <div className={classes.number}>{`${contactPersons}`}</div>
        <div className={classes.text}>{lang.contactPersonTitle}</div>
      </div>
    )
    const businessCustomerBlock = (
      <div className={clsx(classes.blockBusiness, classes.smallBlock)}>
        <div className={classes.number}>{`${companyCustomers}`}</div>
        <div className={classes.text}>{lang.customerList.businessCustomers}</div>
      </div>
    )
    const privateCustomerBlock = (
      <div className={clsx(classes.blockPrivate, classes.smallBlock)}>
        <div className={classes.number}>{`${privateCustomers}`}</div>
        <div className={classes.text}>{lang.customerList.privateCustomers}</div>
      </div>
    )

    const summedUpCustomers = Object.values(customers).reduce((accumulator, current) => current + accumulator, 0)
    const mboBlock = <div className={clsx(classes.bigNumber, classes.mboBlock, classes.bigBlock)}>{summedUpCustomers}</div>
    const crBlock = <div className={clsx(classes.bigNumber, classes.crBlock, classes.bigBlock)}>{summedUpCustomers}</div>

    return (
      <div className={classes.imageContainer}>
        <div className={classes.imageAndTexts}>
          <img src={cleverreachBackgroundImage} />
          {contactPersonBlock}
          {businessCustomerBlock}
          {privateCustomerBlock}
          { mboBlock}
          {crBlock}
        </div>
      </div>
    )
  }
}

const useStyles = makeStyles(theme => ({
  bigNumber: {
    fontSize: 32,
    fontWeight: 500,
  },
  number: {
    fontSize: theme.fontSizes.medium,
    fontWeight: theme.fontWeights.bold,
  },
  text: {
    fontSize: 8,
    marginTop: -2,
  },
  imageContainer: {
    minWidth: 660,
    minHeight: 320,
    display: 'flex',
    justifyContent: 'center',
    borderRadius: 4,
    border: `solid 1px ${theme.borderColor}`,
    backgroundColor: theme.backgroundColor,
    padding: '20px 0',
  },
  imageAndTexts: {
    position: 'relative',
  },
  smallBlock: {
    width: 85,
    height: 85,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  bigBlock: {
    width: 150,
    height: 121,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  blockContactPerson: {
    position: 'absolute',
    top: 0,
    left: 45,
  },
  mboBlock: {
    position: 'absolute',
    top: 61,
    left: 177,
    color: theme.primary,
    marginBottom: 10,
  },
  crBlock: {
    position: 'absolute',
    top: 61,
    left: 428,
    color: theme.black,
    marginBottom: 10,
  },
  blockBusiness: {
    position: 'absolute',
    top: 96,
    left: 0,
  },
  blockPrivate: {
    position: 'absolute',
    top: 192,
    left: 45,
  },
}))

export default CreateImage
